<template>
  <div class="">
    <h2 class="d-flex justify-content-between">
      {{$t('message.teams')}}
      <button class="btn button-link p-0" @click.prevent.stop="openTeam({})">+ {{ $t('message.add_team') }}
      </button>
    </h2>
    <div class="row">
      <div class="col-md-12 search-wrapper">
        <div class="form-row">
          <div class="col-md-12">

            <input id="fname"
                   v-on:keyup="filterTeams"
                   name="search-user"
                   class="form-control mb-3"
                   type="text"
                   placeholder="Find a team"
                   aria-label="Search team">
          </div>
        </div>
      </div>
    </div>
    <div class="table-top-border border-bottom-grey mt-5"></div>
    <table id="table-teams" class="table dataTable dataTableNoBtns  ">
      <thead>
      <tr>
        <th scope="col">{{ $t('message.team_name') }}</th>
        <th>{{$t('message.users')}}</th>
        <th>{{$t('message.managers')}}</th>
        <!--        <th>{{$t('message.status')}}</th>-->
        <th class="u-actions" scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <template v-for="team in teams">
        <tr>
          <td>
            {{team.Title}}
          </td>
          <td>
            <span class="d-block small" v-for="name in nameList(team.users).slice(0,5)">
              {{name}}
            </span>
            <span class="mt-1 d-block small" v-if="nameList(team.users).length>5">
              +{{nameList(team.users).length - 5}}
            </span>
          </td>
          <td>
             <span class="d-block small" v-for="name in nameList(team.managedBy).slice(0,5)">
              {{name}}
            </span>
            <span class="mt-1 d-block small" v-if="nameList(team.managedBy).length>5">
              +{{nameList(team.managedBy).length - 5}}
            </span>
          </td>
          <td>
            <button @click.prevent.stop="openTeam(team)" class=" btn p-0">
              <img class="img-fluid"
                   src="@/assets/images/user-list-manager/edit.svg"
                   alt="Icon edit">
            </button>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
    <pager @setPage="setPage" :active-page="activePage" :result-count="resultCount"
           :results-perpage="resultsPerpage"></pager>
  </div>
</template>

<script>
  import Pager from "../Pager";

  export default {
    components: {
      pager: Pager
    },
    props: {},
    data() {
      return {
        activeTeam: null,
        activePage: 1,
        resultCount: 0,
        resultsPerpage: 10,
        filter: null,
        start: 0,
        teams: []
      }
    },
    created() {
      this.getTeams();
    },
    mounted() {
    },
    computed: {
      offset() {
        return this.resultsPerpage * (this.activePage - 1)
      }
    },
    methods: {
      setPage(pagenumber) {
        let offset = this.resultsPerpage * (pagenumber - 1);
        this.start = offset;
        this.activePage = pagenumber
        this.getTeams(this.filter);
      },
      nameList(list) {
        const users = [];
        list.forEach(user => {
          // if(users.length < 5){
          users.push(user.lastname + ' ' + user.firstname)
          // }

        });
        // let sortedusers = _.sortBy(users, [user => user.toLowerCase()])
        let sortedusers = _.sortBy(users, [user => user.lastname ? user.lastname.toLowerCase() : user.lastname])
        // return users.join(', ')
        return sortedusers
      },
      openTeam(team) {
        this.$emit('openTeam', team)
      },

      filterTeams(e) {
        this.activePage = 1
        const val = e.target.value;
        this.filter = val;
        this.start = 0;
        this.getTeams(this.filter)
      },
      getTeams(filter = null) {
        // console.log('loading teams')
        let ep = '/teams/teamlist?status=1';
        let relation_search = '';
        let paging = '&_start=' + this.offset + '&_limit=' + this.resultsPerpage

        let q = ep;
        let join = '&';
        if (this.role !== 'manager') {
          q += paging;
        }
        let cq = '/teams/count?status=1';

        if (filter) {
          q += join + relation_search + 'Title_contains=' + filter;
          cq += '&' + relation_search + 'Title_contains=' + filter;
        }

        this.axios.get(q).then(users => users.data) //todo change to /teams/myteams
          .then(res => {
            let data = res;

            this.teams = data;
          });

        this.axios.get(cq).then(users => users.data)
          .then(res => {
            const data = res;
            this.resultCount = data;
          })

      },

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Teams/TeamList.vue